var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "126.597px",
    height: "49.279px",
    viewBox: "0 0 126.597 49.279",
    enableBackground: "new 0 0 126.597 49.279",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#939598",
    d: "M122.341,29.934"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M44.34,32.202h-3.714V11.931h5.571c2.486,0,3.829,0.425,5.029,1.549c1.229,1.155,1.942,2.948,1.942,4.804 c0,4.102-2.314,6.413-6.428,6.413h-2.4V32.202 M45.854,21.262c2.344,0,3.486-0.974,3.486-2.979c0-2.008-1.171-2.919-3.715-2.919 H44.34v5.897H45.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.508,27.919l-1.715,4.283h-3.94l8.257-20.697h2.8l7.999,20.697h-3.971l-1.627-4.283H56.508z M60.48,17.431l-2.771,7.296 h5.429L60.48,17.431z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M84.651,32.202h-4.572l-5.142-8.145H74.45v8.145h-3.713V11.931h5.514c4.287,0,6.744,2.188,6.744,5.987 c0,3.099-1.543,5.138-4.344,5.743L84.651,32.202 M75.538,21.262c2.371,0,3.629-1.096,3.629-3.131c0-1.978-1.258-3.011-3.572-3.011 H74.45v6.142H75.538z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "96.452,11.93 101.137,11.93 93.079,21.291 101.565,32.202 96.679,32.202 89.907,23.084 89.45,23.57 89.45,32.202  85.736,32.202 85.736,11.93 89.45,11.93 89.45,20.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1C2E",
    points: "91.049,35.471 77.361,49.279 88.242,49.279 102.024,35.471  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1C2E",
    points: "112.905,35.471 102.024,35.471 115.715,21.637 126.597,21.637  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.834,21.607H15.953l8.646,8.737c-2.074,1.155-4.462,1.814-7.006,1.814c-7.94,0-14.376-6.415-14.376-14.33 c0-7.912,6.436-14.328,14.376-14.328c7.941,0,14.378,6.416,14.378,14.328c0,2.574-0.681,4.99-1.874,7.077L26.834,21.607  M26.972,32.743l2.671,2.7h10.882l-8.016-8.102c1.812-2.775,2.866-6.091,2.866-9.654C35.375,7.92,27.457,0,17.688,0 S0,7.92,0,17.688c0,9.77,7.919,17.688,17.688,17.688C21.093,35.376,24.273,34.41,26.972,32.743"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.79af42573440e0ae1ef3bb1aeeddf673.svg";
export { ForwardRef as ReactComponent };